import React from "react";
import Results from "../results/index";

export default function IndexPage() {
  return (
    <div className="relative w-full mx-auto">
      <Results />
    </div>
  );
}
